export default __webpack_public_path__ + "static/media/CheckmarkInCircle.8234e071.svg";